import { LOGOS } from "@/components/marketing/logos";

export default function Technologies() {
    return (
        <section className="tech" id="integrations" data-testid="v2-technologies">
            <div className="container">
                <div className="tech__head reveal">
                    <span className="tech__eyebrow">Supported Technologies</span>
                    <h3 className="tech__title">
                        Works with the tools your business already runs on.
                    </h3>
                    <p className="tech__sub">
                        The patented C-ORE Agentic Engine plugs into your
                        existing stack — accounting, CRM, spreadsheets and
                        government systems — and turns scattered data into
                        leadership intelligence.
                    </p>
                </div>

                <div
                    className="tech__grid reveal"
                    role="list"
                    aria-label="Supported technologies"
                >
                    {LOGOS.map(({ name, node }) => (
                        <div
                            className="tech__tile"
                            role="listitem"
                            key={name}
                            title={name}
                            data-testid={`v2-logo-${name.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            <div className="tech__mark">{node}</div>
                            <span className="tech__name">{name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
